import { render, staticRenderFns } from "./LegalWarning.html?vue&type=template&id=025999fa&external"
import script from "./LegalWarning.ts?vue&type=script&lang=ts&external"
export * from "./LegalWarning.ts?vue&type=script&lang=ts&external"
import style0 from "./LegalWarning.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports